export enum HeroBannerTextAreaPositionEnum {
  CENTER = 'center',
  LEFT_CENTER = 'left_center',
  BOTTOM_CENTER = 'bottom_center',
}
